import { buildRecordFromKeyList } from "../build-record-from-key-list";
import { DEFAULT_SUPPLY_ELASTICITY } from "./default-supply-elasticity";
import { MODAL_SPLIT_MODE_LIST } from "./modal-split-mode";
export const EMPTY_TRANSPORT_MODAL_SPLIT_PARAMETERS = {
    baseModalSplit: buildRecordFromKeyList(MODAL_SPLIT_MODE_LIST, () => 0),
    targetModalSplit: buildRecordFromKeyList(MODAL_SPLIT_MODE_LIST, () => 0),
    supplyElasticity: DEFAULT_SUPPLY_ELASTICITY,
};
